/* Moved from the inline <script> in snippets/products-toolbar.liquid (PageSpeed batch 6). Guarded so it runs once even if the snippet renders twice. */
(function () {
  if (window.__kgProductsToolbarDrawersLoaded) return;
  window.__kgProductsToolbarDrawersLoaded = true;



  let activeNestedDrawerId = null;
  let facetFiltersForm = null;
  window.__kgProductsToolbarNestedDrawer = true;
  
  document.addEventListener('DOMContentLoaded', function () {
    const overlay = document.getElementById('custom-filter-overlay');
    const filterDrawer = document.getElementById('FilterDrawer');
    const sortDrawer = document.getElementById('SortDrawer');
  
    function renderVisibleFilters() {
      const hiddenContainer = document.getElementById('active-filters-hidden');
      const visibleContainer = document.getElementById('VisibleActiveFilters');
      const desktopCount = document.getElementById('filter-count');
      const mobileCount = document.getElementById('filter-count-mobile');
      if (!hiddenContainer || !visibleContainer) return;
  
      const activeFiltersWrapper = hiddenContainer.querySelector('.active-filters');
      const clearButton = hiddenContainer.querySelector('.js-clear-all');
  
      visibleContainer.innerHTML = '';
  
      if (activeFiltersWrapper) {
        activeFiltersWrapper.querySelectorAll('.active-filter').forEach(filter => {
          visibleContainer.appendChild(filter.cloneNode(true));
        });
      }
  
      if (clearButton) {
        visibleContainer.appendChild(clearButton.cloneNode(true));
      }
  
      const activeCount = hiddenContainer.querySelectorAll('.active-filter').length;
  
      if (desktopCount) {
        desktopCount.textContent = activeCount;
        desktopCount.style.display = activeCount > 0 ? 'inline-flex' : 'none';
      }
      if (mobileCount) {
        mobileCount.textContent = activeCount;
        mobileCount.style.display = activeCount > 0 ? 'inline' : 'none';
      }
  
      visibleContainer.style.display = activeCount > 0 ? 'flex' : 'none';
    }

    function setClearAllLoading(activeLink) {
      document.querySelectorAll('.js-clear-all').forEach(link => {
        if (link === activeLink || link.href === activeLink.href) {
          link.classList.add('is-loading');
          link.setAttribute('aria-busy', 'true');
          link.setAttribute('aria-disabled', 'true');
        }
      });
    }

    document.getElementById('VisibleActiveFilters')?.addEventListener('click', function (event) {
      const filterLink = event.target.closest('.active-filter, .js-clear-all');
      if (!filterLink) return;

      const facetFilters = Array.from(document.querySelectorAll('facet-filters')).find((element) => {
        return typeof element.applyFilters === 'function';
      });

      if (facetFilters) {
        event.preventDefault();
      }

      if (filterLink.classList.contains('js-clear-all')) {
        setClearAllLoading(filterLink);
      } else {
        filterLink.classList.add('is-loading');
        filterLink.setAttribute('aria-busy', 'true');
      }

      if (facetFilters) {
        const searchParams = new URL(filterLink.href).searchParams.toString();
        facetFilters.applyFilters(searchParams, event);
      }
    });
	  
    function bindFacetFiltersForm() {
      facetFiltersForm = document.getElementById('facet-filters-form');
      if (!facetFiltersForm) return;
  
      facetFiltersForm.addEventListener('change', onFacetFiltersChange);
    }
  
    function onFacetFiltersChange(e) {
      e.preventDefault();
  
      const formData = new FormData(facetFiltersForm);
      const searchParams = new URLSearchParams(formData).toString();
      const newUrl = `${window.location.pathname}?${searchParams}`;
  
      window.history.pushState({}, '', newUrl);
  
      fetch(newUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
  
          const newProducts = doc.querySelector('#product-grid');
          const currentProducts = document.querySelector('#product-grid');
          if (newProducts && currentProducts) {
            currentProducts.innerHTML = newProducts.innerHTML;
          }
  
          const newHiddenFilters = doc.querySelector('#active-filters-hidden');
          const currentHiddenFilters = document.querySelector('#active-filters-hidden');
          if (newHiddenFilters && currentHiddenFilters) {
            currentHiddenFilters.innerHTML = newHiddenFilters.innerHTML;
          }
  
          const newFiltersForm = doc.querySelector('#facet-filters-form');
          if (newFiltersForm) {
            const parent = facetFiltersForm.parentElement;
            facetFiltersForm.remove(); // ta bort gammal
            parent.appendChild(newFiltersForm);
            bindFacetFiltersForm(); // 👉 Lägg till ny event-listener
          }
  
          renderVisibleFilters();
          bindNestedDrawerOpeners();
  
          const event = new Event('on:facet-filters:updated');
          document.dispatchEvent(event);
        })
        .catch(err => console.error('Filtrering misslyckades:', err));
    }
  
    // Kör när filtrering är klar
    document.addEventListener('on:facet-filters:updated', function () {
      renderVisibleFilters();
      bindNestedDrawerOpeners();
    });
  
    // Direkt vid laddning
    requestAnimationFrame(() => {
      renderVisibleFilters();
      bindNestedDrawerOpeners();
    });
  
    bindFacetFiltersForm();
  
    // Resten (drawer hantering) är som du hade – korrekt.
    function showOverlay() { overlay?.classList.add('active'); }
    function hideOverlay() { overlay?.classList.remove('active'); }
    function openFilterDrawer() {
      filterDrawer?.classList.add('open');
      document.body.classList.add('drawer-open');
      showOverlay();
      document.querySelector('.floating-filter-container')?.classList.remove('visible');
    }
function closeFilterDrawer() {
  if (!filterDrawer) return;
  filterDrawer.classList.add('closing');
  filterDrawer.classList.remove('nested-open', 'nested-filter-open', 'nested-menu-open');
  document.body.classList.remove('drawer-open');
  setTimeout(() => {
    filterDrawer.classList.remove('open', 'closing');
    hideOverlay();

  
    const grid = document.querySelector('.main-products-grid__results');
    const button = document.querySelector('.floating-filter-container');
    if (!grid || !button) return;

    const rect = grid.getBoundingClientRect();
    const inView = rect.top < window.innerHeight && rect.bottom > 0;

    if (inView) {
      button.classList.add('visible');
    }
  }, 300);
}
    function openSortDrawer() { sortDrawer?.classList.add('open'); document.body.classList.add('drawer-open'); showOverlay(); }
    function closeSortDrawer() { if (!sortDrawer) return; sortDrawer.classList.add('closing'); document.body.classList.remove('drawer-open'); setTimeout(() => { sortDrawer.classList.remove('open', 'closing'); hideOverlay(); }, 300); }

    function getAjaxFacetFilters() {
      return Array.from(document.querySelectorAll('facet-filters')).find((element) => {
        return typeof element.applyFilters === 'function';
      });
    }

    function setSortLoading(input) {
      sortDrawer?.querySelectorAll('.custom-radio.is-loading').forEach(label => {
        label.classList.remove('is-loading');
        label.removeAttribute('aria-busy');
      });

      const label = input?.closest('.custom-radio');
      if (label) {
        label.classList.add('is-loading');
        label.setAttribute('aria-busy', 'true');
      }
    }

    function clearSortLoading() {
      sortDrawer?.querySelectorAll('.custom-radio.is-loading').forEach(label => {
        label.classList.remove('is-loading');
        label.removeAttribute('aria-busy');
      });
    }

    sortDrawer?.querySelector('#sort-form-default')?.addEventListener('submit', function(event) {
      event.preventDefault();
    });

    sortDrawer?.addEventListener('change', function(event) {
      const input = event.target.closest('input[name="sort_by"]');
      if (!input) return;

      const facetFilters = getAjaxFacetFilters();
      if (!facetFilters) {
        const fallbackUrl = new URL(window.location.href);
        fallbackUrl.searchParams.set('sort_by', input.value);
        fallbackUrl.searchParams.delete('page');
        window.location.href = fallbackUrl.toString();
        return;
      }

      event.preventDefault();
      setSortLoading(input);

      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set('sort_by', input.value);
      searchParams.delete('page');

      Promise.resolve(facetFilters.applyFilters(searchParams.toString(), event))
        .then(() => {
          closeSortDrawer();
        })
        .finally(() => {
          clearSortLoading();
        });
    });

    function resetNestedDrawerScroll(drawer) {
      if (!drawer) return;
      const drawerContent = drawer.querySelector('.filter__drawer-content');
      const filterDrawerContent = drawer.closest('#FilterDrawer')?.querySelector(':scope > .drawer-content');
      const facetFilters = drawer.closest('facet-filters');
      if (filterDrawerContent) filterDrawerContent.scrollTop = 0;
      if (facetFilters) facetFilters.scrollTop = 0;
      drawer.scrollTop = 0;
      if (drawerContent) drawerContent.scrollTop = 0;
    }

    function openNestedDrawer(drawerId) {
      const drawer = document.getElementById(drawerId);
      if (!drawer) return;
      const isMenuDrawer = drawerId.startsWith('menu-drawer');
      filterDrawer?.classList.add('nested-open');
      filterDrawer?.classList.toggle('nested-menu-open', isMenuDrawer);
      filterDrawer?.classList.toggle('nested-filter-open', !isMenuDrawer);
      document.querySelectorAll('.filter__drawer-panel.open').forEach(panel => {
        if (panel.id !== drawerId) panel.classList.remove('open');
      });
      resetNestedDrawerScroll(drawer);
      drawer.classList.add('open');
      requestAnimationFrame(() => {
        resetNestedDrawerScroll(drawer);
      });
      document.body.classList.add('drawer-open');
    }
    function closeAllDrawers() {
  document.querySelectorAll('.filter-drawer.open, .sort-drawer.open, .filter__drawer-panel.open').forEach(drawer => {
    drawer.classList.add('closing');
    setTimeout(() => {
      drawer.classList.remove('open', 'closing');
    }, 300);
  });

  filterDrawer?.classList.remove('nested-open', 'nested-filter-open', 'nested-menu-open');
  document.body.classList.remove('drawer-open');
  setTimeout(hideOverlay, 200);

  const grid = document.querySelector('.main-products-grid__results');
  const button = document.querySelector('.floating-filter-container');
  if (!grid || !button) return;

  const rect = grid.getBoundingClientRect();
  const inView = rect.top < window.innerHeight && rect.bottom > 0;

  if (inView) {
    button.classList.add('visible');
  }
}

    function bindNestedDrawerOpeners() {
      if (window.__kgNestedDrawerDelegated) return;
      window.__kgNestedDrawerDelegated = true;
      document.addEventListener('click', nestedDrawerClickHandler);
    }

    function nestedDrawerClickHandler(e) {
      const trigger = e.target.closest('.open-nested-drawer');
      if (!trigger) return;

      const drawerId = trigger.getAttribute('data-drawer-id');
      if (!drawerId) return;

      e.preventDefault();
      e.stopPropagation();
      activeNestedDrawerId = drawerId;
      openNestedDrawer(drawerId);
      const parentDetails = trigger.closest('details');
      if (parentDetails) {
        parentDetails.setAttribute('open', true);
      }
    }
  
    overlay?.addEventListener('click', closeAllDrawers);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAllDrawers(); });
    document.addEventListener('click', (e) => {
      const openDrawer = document.querySelector('.filter__drawer-panel.open');
      if (!openDrawer) return;
      const isClickInside = openDrawer.contains(e.target);
      const isToggle = e.target.closest('.open-nested-drawer');
      const isSummary = e.target.closest('summary');
      if (!isClickInside && !isToggle && !isSummary) {
        openDrawer.classList.remove('open');
        filterDrawer?.classList.remove('nested-open', 'nested-filter-open', 'nested-menu-open');
        document.body.classList.remove('drawer-open');
      }
    });
  
    window.openFilterDrawer = openFilterDrawer;
    window.closeFilterDrawer = closeFilterDrawer;
    window.openSortDrawer = openSortDrawer;
    window.closeSortDrawer = closeSortDrawer;
    
  });
  
})();
